import moment from 'moment'
import 'moment/locale/zh-cn'

moment.defineLocale('zh-cn-m', {
  parentLocale: 'zh-cn',
  relativeTime: {
    future: '%s',
    past: '逾期 %s',
  },
})
moment.locale('zh-cn-m')

// Wrap for moment
const moments = function (...args) {
  return moment.utc(...args)
}

moments.moment = moment

moments.MS_IN_DAY = 86400000
moments.DATE_FORMAT = 'YYYY-MM-DD'
moments.DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'

moments.utc = (...args) => moment.utc(...args)
moments.todate = t => moment.utc(t).format(moments.DATE_FORMAT)
moments.toDatetime = t => moment.utc(t).local().format(moments.DATETIME_FORMAT)
moments.toDatetimeFlat = t => moment.utc(t).format('YYYYMMDD-HHmmss')
moments.parseDate = t => moment.utc(t, moments.DATE_FORMAT)
moments.daysBetween = (a, b) => Math.round((a - b) / moments.MS_IN_DAY)
moments.monthsBetween = (a, b) => {
  let month = 0
  month += (a.year() - b.year()) * 12
  month += (a.month() - b.month())
  return month
}

export default moments



// WEBPACK FOOTER //
// ./client/src/utils/moments.js